import { palette } from '../global/palette';
import ExpandRight from '@tdcerhverv/parrotfish/icons/ExpandRight';
import ExpandLeft from '@tdcerhverv/parrotfish/icons/ExpandLeft';
export const MuiTimePicker = {
    MuiTimePicker: {
        defaultProps: {
            ampm: false,
            components: {
                RightArrowIcon: ExpandRight,
                LeftArrowIcon: ExpandLeft,
            },
        },
    },
};
export const MuiClock = {
    MuiClock: {
        styleOverrides: {
            pin: {
                backgroundColor: palette.primary.light,
            },
            squareMask: {
                backgroundColor: palette.grey[200],
            },
        },
    },
};
export const MuiClockPicker = {
    MuiClockPicker: {
        styleOverrides: {
            root: {
                '& button': {
                    width: 25,
                    '&:disabled': {
                        fill: palette.grey[400],
                    },
                },
            },
        },
    },
};
export const MuiClockPointer = {
    MuiClockPointer: {
        styleOverrides: {
            root: {
                backgroundColor: palette.primary.light,
            },
            thumb: {
                backgroundColor: palette.primary.light,
                borderColor: palette.primary.light,
            },
        },
    },
};
